import React from 'react';
import Checkbox from '@atlaskit/checkbox';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import type { FieldConfigurationComponentProps } from '../../../../../types.tsx';
import { isPeopleFieldInMultiMode } from '../../../../../utils/people-field/index.tsx';
import { CheckboxFieldConfigurationDefaultValue } from '../../../styled.tsx';
import messages from './messages.tsx';

export type Props = Pick<
	FieldConfigurationComponentProps,
	'onUpdate' | 'field' | 'tooltipDelay' | 'testId'
>;

export const Mode = ({ field, onUpdate, tooltipDelay, testId }: Props) => {
	const intl = useIntl();
	const isModifyPropertyConfigurationDisabled = !field.operations.canModifyPropertyConfiguration;
	const onChange = () => {
		let { defaultValue } = field;
		const isMulti = !isPeopleFieldInMultiMode(field);
		if (!isMulti && Array.isArray(defaultValue) && defaultValue.length > 1) {
			defaultValue = [];
		}
		onUpdate({
			...field,
			defaultValue,
			configuration: { isMulti },
		});
	};

	return (
		<CheckboxFieldConfigurationDefaultValue>
			<Tooltip
				content={
					isModifyPropertyConfigurationDisabled
						? intl.formatMessage(messages.singleModeDisabledTooltip)
						: null
				}
				delay={tooltipDelay}
			>
				<Checkbox
					isChecked={!isPeopleFieldInMultiMode(field)}
					isDisabled={isModifyPropertyConfigurationDisabled}
					label={intl.formatMessage(messages.singleModeLabel)}
					onChange={onChange}
					testId={testId}
				/>
			</Tooltip>
		</CheckboxFieldConfigurationDefaultValue>
	);
};
